module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/osbornebulls.423eff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/osbornebulls.jpg
// module id = dgDk
// module chunks = 0